import { render, staticRenderFns } from "./CabeceraModalVisualizacion.vue?vue&type=template&id=0a4cdd49&scoped=true&"
import script from "./CabeceraModalVisualizacion.vue?vue&type=script&lang=ts&"
export * from "./CabeceraModalVisualizacion.vue?vue&type=script&lang=ts&"
import style0 from "./CabeceraModalVisualizacion.vue?vue&type=style&index=0&id=0a4cdd49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4cdd49",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0a4cdd49', component.options)
    } else {
      api.reload('0a4cdd49', component.options)
    }
    module.hot.accept("./CabeceraModalVisualizacion.vue?vue&type=template&id=0a4cdd49&scoped=true&", function () {
      api.rerender('0a4cdd49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/ConfigAutorizaciones/CabeceraModalVisualizacion.vue"
export default component.exports